<div class="car-selector">
  <ion-label class="car-selector__title">Select Car</ion-label>
  <swiper-container [modules]="swiperModules" [slidesPerView]="2" [spaceBetween]="12">
    <swiper-slide *ngFor="let car of listCars; let i = index">
      <div class="car-card" (click)="selectCar(i, car)" [ngClass]="{'car-card--active': selectedItem === i}">
        <div class="car-card__image">
          <img [src]="car.icon" [alt]="car.label" />
        </div>
        <span class="car-card__label">{{ car.label }}</span>
        <span class="car-card__capacity">
          <ion-icon name="people"></ion-icon>
          <span>{{ car.countpassager }}</span>
          <ion-icon name="briefcase"></ion-icon>
          <span>{{ car.bag }}</span>
        </span>
      </div>
    </swiper-slide>
  </swiper-container>
</div>